import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useErrorCode(interfaceId: any, errorCode: any) {
  return useQuery([queryKeys.errorCode, errorCode], async () => {
    if (!interfaceId || !errorCode) return null
    const { data } = await stationDataConfigApi.getErrorCode(
      interfaceId.toString(),
      errorCode.toString(),
    )
    if (!data) return null

    return data
  })
}

export default useErrorCode
